<template>
    <v-container fill-height fluid grid-list-xl>
        <v-flex xs8>
            <v-card class="pa-2">
                <v-card-title class="headline"
                    >Phone Number Detail</v-card-title
                >
                <v-form ref="phoneDetailForm" lazy-validation>
                    <v-container>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field
                                    label="Phone Number"
                                    :mask="phoneMask"
                                    :disabled="disableNumberInput"
                                    v-model="number"
                                    :rules="[
                                        rules.required,
                                        (value) => rules.min(value, 11),
                                    ]"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    disabled
                                    label="Date"
                                    :value="createdAt"
                                />
                            </v-flex>
                            <v-flex xs6>
                                <v-text-field
                                    disabled
                                    label="Carrier"
                                    :value="carrier"
                                    :disabled="!isAdmin()"
                                />
                            </v-flex>
                            <v-flex xs6 v-if="isAdmin()">
                                <!-- <v-text-field
                                    label="User"
                                    v-model="user"
                                    required
                                /> -->
                                <v-autocomplete
                                    label="User"
                                    hide-no-data
                                    ref="user"
                                    v-model="user"
                                    :items="users"
                                    :search-input.sync="loadUsers"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6 v-if="isAdmin()">
                                <v-text-field
                                    label="Description"
                                    v-model="description"
                                    :rules="[rules.required]"
                                    required
                                />
                            </v-flex>
                            <v-flex xs12 class="pt-0" v-if="!isAdmin()">
                                <v-text-field
                                    label="Description"
                                    v-model="description"
                                    :rules="[rules.required]"
                                    :disabled="!isAdmin()"
                                    required
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-layout row>
                                    <v-flex xs4>
                                        <v-text-field
                                            :mask="phoneMask"
                                            label="Forward Number"
                                            v-model="forwardNumber"
                                            :rules="[
                                                (value) => rules.min(value, 11),
                                            ]"
                                        />
                                    </v-flex>
                                    <v-flex xs8 class="pl-4 mt-3">
                                        <v-layout row>
                                            <v-checkbox
                                                label="Record Calls"
                                                v-model="recordCalls"
                                                :disabled="!isAdmin()"
                                                color="success"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                label="Send Undelivered Report"
                                                v-model="undeliveredReport"
                                                :disabled="!isAdmin()"
                                                color="success"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                label="To Communication Tab"
                                                v-model="toCommunicationTab"
                                                :disabled="!isAdmin()"
                                                color="success"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                label="To Voicemail"
                                                v-model="toVoicemail"
                                                color="success"
                                                hide-details
                                            ></v-checkbox>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs6>
                                <div
                                    v-for="(email, index) in emailList"
                                    v-if="showEmails()"
                                >
                                    <v-layout row class="pl-3">
                                        <v-text-field
                                            label="Email"
                                            v-model="email.address"
                                            :rules="[rules.email]"
                                        ></v-text-field>
                                        <v-btn
                                            @click="addEmail"
                                            flat
                                            icon
                                            color="success"
                                        >
                                            <v-icon>mdi-plus-circle</v-icon>
                                        </v-btn>
                                        <v-btn
                                            :disabled="index == 0"
                                            @click="removeEmail(index)"
                                            flat
                                            icon
                                            color="#f55a4e"
                                        >
                                            <v-icon
                                                >mdi-minus-circle-outline</v-icon
                                            >
                                        </v-btn>
                                    </v-layout>
                                </div>
                            </v-flex>
                            <v-flex xs6 class="pt-0">
                                <v-select
                                    :disabled="!isAdmin()"
                                    hide-details
                                    :items="applications"
                                    label="Applicaton"
                                    ref="Applicaton"
                                    v-model="application"
                                    box
                                    item-text="`${data.item.appName}`"
                                >
                                    <template
                                        slot="selection"
                                        slot-scope="data"
                                    >
                                        {{ data.item.appName }}
                                    </template>
                                    <template slot="item" slot-scope="data">
                                        <v-list-tile-content>
                                            <v-list-tile-title
                                                v-html="`${data.item.appName}`"
                                            >
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-checkbox
                                class="ml-3 mt-0"
                                label="Verified By Twilio"
                                v-model="verifiedByTwilio"
                                color="success"
                                :disabled="!isAdmin()"
                                hide-details
                            ></v-checkbox>
                            <v-flex class="xs12 text-xs-right mt-3">
                                <v-btn
                                    dark
                                    color="default"
                                    @click.stop="cancel"
                                    class="mr-2"
                                    >cancel</v-btn
                                >
                                <v-btn
                                    color="success"
                                    @click.stop="savePhoneDetail"
                                    >Save</v-btn
                                >
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
import moment from "moment";
import { formatCurrency } from "../utils/helpers.js";
import ky from "../utils/ky.js";

export default {
    data: () => ({
        number: "",
        createdAt: "",
        description: "",
        emails: "",
        carrier: "",
        forwardNumber: "",
        active: false,
        recordCalls: false,
        undeliveredReport: false,
        toCommunicationTab: false,
        verifiedByTwilio: false,
        toVoicemail: false,
        user: "",
        application: "",
        phoneMask: "#(###) ### - ####",
        disableNumberInput: false,
        emailList: [],

        applications: [],
        users: [],

        loadUsers: null,

        carriers: ["PLIVO", "BANDWIDTH", "TWILIO"],
        rules: {
            required: (value) => !!value || "Required.",
            min: (value, count) => {
                if (!value) return true;

                return (
                    value.length >= count ||
                    `Must be at least ${count} characters`
                );
            },
            email: (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return !value || pattern.test(value) || "Invalid e-mail.";
            },
            emailRequired: (value) => {
                return !!value || !this.toVoicemail || "Required";
            },
        },
    }),
    watch: {
        async loadUsers(value) {
            if (!value) return;

            this.loadUserList();
        },
    },
    async created() {
        this.load();
    },
    methods: {
        async load() {
            if (!this.$route.params.id) {
                this.createdAt = moment(new Date()).format("L");

                return;
            }
            const response = await this.$http.get(
                "api/broadcast/getPhoneNumberDetail?phoneNumber=" +
                    this.$route.params.id,
            );

            await this.loadApplications(response.carrier);
            await this.loadUserList();

            this.users = this.users.sort();

            this.number = response.number;
            this.description = response.description;
            this.emailList = response.emails
                ? response.emails
                      .split(",")
                      .map((email) => ({ address: email.replace(" ", "") }))
                : [{ address: "" }];
            this.carrier = response.carrier;
            this.forwardNumber = response.forwardNumber;
            this.active = response.active;
            this.recordCalls = response.recordCalls;
            this.undeliveredReport = response.undeliveredReport;
            this.toCommunicationTab = response.toCommunicationTab;
            this.verifiedByTwilio = response.verifiedByTwilio;
            this.user = response.user;
            this.toVoicemail = response.toVoicemail;
            this.application = this.applications.find(
                (a) => a.appID == response.appID,
            );

            this.createdAt = moment(response.createdAt).format("L");

            this.disableNumberInput = true;
        },
        async loadApplications(carrier) {
            const url =
                carrier == "TWILIO"
                    ? "api/broadcast/getTwilioApps"
                    : carrier == "PLIVO"
                    ? "api/broadcast/getPlivoApps"
                    : "api/broadcast/getBandwidthApps";

            this.applications = await this.$http.get(url);
        },
        async loadUserList() {
            const response = await this.$http.get("odata/users?");

            this.users = response.value.map((user) => user.userName);
        },
        async savePhoneDetail() {
            if (!this.$refs.phoneDetailForm.validate()) return;

            const emails = this.emailList.map((e) => e.address).join(", ");

            if (this.toVoicemail && !emails) {
                this.$notify({
                    text:
                        "You need to enter an email in order to receive voicemails.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const data = {
                number: this.number,
                createdAt: this.createdAt,
                description: this.description,
                emails,
                carrier: this.carrier,
                forwardNumber: this.forwardNumber,
                active: true,
                recordCalls: this.recordCalls,
                undeliveredReport: this.undeliveredReport,
                toCommunicationTab: this.toCommunicationTab,
                verifiedByTwilio: this.verifiedByTwilio,
                toVoicemail: this.toVoicemail,
                user: this.user,
                appID: this.application ? this.application.appID : null,
                appDescription: this.application
                    ? this.application.appName
                    : null,
            };

            if (data.forwardNumber) {
                data.forwardNumber =
                    data.forwardNumber.length == 11
                        ? data.forwardNumber
                        : "1" + data.forwardNumber;
            }

            await this.$http.post("api/broadcast/savePhoneNumber", data);

            if (this.isAdmin()) {
                this.$router.push({
                    name: "PhoneNumbers",
                });
            } else {
                this.$notify({
                    text: "Phone Number Settings Saved.",
                    group: "notification",
                    type: "success",
                });
            }
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        cancel() {
            if (this.isAdmin()) {
                this.$router.push({
                    name: "PhoneNumbers",
                });
            } else {
                this.$router.go(-1);
            }
        },
        addEmail() {
            this.emailList.push({ address: "" });
        },
        removeEmail(index) {
            this.emailList.splice(index, 1);
        },
        showEmails() {
            //if (this.toCommunicationTab && !this.toVoicemail) return false;

            return true;
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
</style>
